// Mock data for HouseOfSeya jewellery store

export const HERO_SLIDES = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGRpYW1vbmQlMjBuZWNrbGFjZXxlbnwwfHx8fDE3ODQ5MTI1MTh8MA&ixlib=rb-4.1.0&q=85&w=2000',
    tagline: 'The Autumn Edit',
    title: 'A New Language of Luxury',
    cta: 'Explore',
    href: '/collections/new-collection'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBkaWFtb25kJTIwamV3ZWxsZXJ5fGVufDB8fHx8MTc4NDkxMjQ2NXww&ixlib=rb-4.1.0&q=85&w=2000',
    tagline: 'Gold Reimagined',
    title: 'Same gold. New feeling.',
    cta: 'Recycle Your Gold',
    href: '/pages/gold-reimagined'
  },
  {
    id: 3,
    image: 'https://images.pexels.com/photos/36599395/pexels-photo-36599395.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2000',
    tagline: 'Follow The Feeling',
    title: 'Diamonds Made To Move With You',
    cta: 'Explore The Edit',
    href: '/collections/follow-the-feeling'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1763628212781-7d52844cf358?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGVhcnJpbmdzfGVufDB8fHx8MTc4NDkxMjUyNHww&ixlib=rb-4.1.0&q=85&w=2000',
    tagline: 'New Arrivals',
    title: 'New Feelings, New Pieces',
    cta: 'Explore',
    href: '/collections/new-collection'
  }
];

export const CATEGORIES = [
  {
    id: 'earrings',
    name: 'Earrings',
    image: 'https://images.unsplash.com/photo-1693212793204-bcea856c75fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxkaWFtb25kJTIwZWFycmluZ3N8ZW58MHx8fHwxNzg0OTEyNDY1fDA&ixlib=rb-4.1.0&q=85&w=1000',
    href: '/collections/earrings'
  },
  {
    id: 'bracelets',
    name: 'Bracelets',
    image: '/product_detail5.jpeg',
    href: '/collections/bracelets'
  },
  {
    id: 'necklaces',
    name: 'Necklaces',
    image: 'https://images.pexels.com/photos/20838859/pexels-photo-20838859.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000',
    href: '/collections/necklaces'
  }
];

export const SHAPES = [
  { name: 'Round', img: 'https://houseofquadri.com/cdn/shop/files/01.webp?width=200' },
  { name: 'Oval', img: 'https://houseofquadri.com/cdn/shop/files/02.webp?width=200' },
  { name: 'Princess', img: 'https://houseofquadri.com/cdn/shop/files/03.webp?width=200' },
  { name: 'Emerald', img: 'https://houseofquadri.com/cdn/shop/files/04.webp?width=200' },
  { name: 'Radiant', img: 'https://houseofquadri.com/cdn/shop/files/05.webp?width=200' },
  { name: 'Heart', img: 'https://houseofquadri.com/cdn/shop/files/07.webp?width=200' },
  { name: 'Cushion', img: 'https://houseofquadri.com/cdn/shop/files/cushion_60d5ebd6-5556-4203-970d-c4e3d87cc7cb.png?width=200' },
  { name: 'Pear', img: 'https://houseofquadri.com/cdn/shop/files/06.webp?width=200' },
  { name: 'Marquise', img: 'https://houseofquadri.com/cdn/shop/files/09.webp?width=200' },
  { name: 'Asscher', img: 'https://houseofquadri.com/cdn/shop/files/asscher.webp?width=200' }
];

// Mobile "Diamonds that don't cost the Earth" section plays this video
// full-screen instead of the static desktop image. Placeholder — swap for
// the real House of Seya brand video file/URL when available.
export const DIAMOND_SECTION_VIDEO = 'https://cdn.coverr.co/videos/coverr-close-up-of-a-diamond-ring-2633/1080p.mp4';

const PRODUCT_IMAGES = [
  'https://images.unsplash.com/photo-1543294001-f7cd5d7fb516?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
  'https://images.unsplash.com/photo-1624588057318-5f1b2eb81012?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
  'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
  'https://images.pexels.com/photos/2735981/pexels-photo-2735981.jpeg?auto=compress&cs=tinysrgb&w=900',
  'https://images.unsplash.com/photo-1605100804763-247f67b3557e?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
  'https://images.unsplash.com/photo-1633934542430-0905ccb5f050?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
  'https://images.unsplash.com/photo-1512163143273-bde0e3cc7407?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
  'https://images.pexels.com/photos/10075092/pexels-photo-10075092.jpeg?auto=compress&cs=tinysrgb&w=900',
  'https://images.unsplash.com/photo-1693212793204-bcea856c75fe?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
  'https://images.unsplash.com/photo-1693213085235-ea6deadf8cee?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
  'https://images.pexels.com/photos/5370644/pexels-photo-5370644.jpeg?auto=compress&cs=tinysrgb&w=900',
  'https://images.pexels.com/photos/10976654/pexels-photo-10976654.jpeg?auto=compress&cs=tinysrgb&w=900',
  '/product_detail_test.jpeg',
  'https://images.pexels.com/photos/30720972/pexels-photo-30720972.jpeg?auto=compress&cs=tinysrgb&w=900'
];

const titles = {
  earrings: ['Solitaire Studs', 'Hoops & Huggies', 'Other Studs', 'Halo Studs'],
  necklaces: ['Pendants', 'Pendant Sets', 'Mangalsutra', 'Trinket Necklace'],
  bracelets: ['Tennis Bracelet', 'Station Bracelet']
};

// e.g. "Hoops & Huggies" -> "hoops-huggies" — used for subcategory routes
// (/collections/earrings/hoops-huggies) and to match products to their
// subcategory nav entry.
export const slugify = (str) => str.toLowerCase().replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

// These real product photos are shown only on specific products so their
// detail-page galleries use actual images instead of the usual repeated
// stock-photo placeholders.
const FEATURED_PRODUCT_IMAGES = {
  'earrings-1': ['/product_detail1.jpeg', '/product_detail2.jpeg', '/product_detail3.jpeg', '/product_detail4.jpeg'],
  'bracelets-1': ['/1.png',  '/2.png','/3.png','/4.png','/5.png'],
};

// Overrides just the main card/detail image for a specific product, leaving
// hoverImage and the rest of its gallery as the usual stock placeholders.
const FEATURED_MAIN_IMAGE = {
  'necklaces-3': '/jerzygorecki-woman-3567600.jpg',
};

function genProducts(category, count) {
  const list = titles[category];
  return list.slice(0, count).map((name, i) => {
    const id = `${category}-${i+1}`;
    const featuredImages = FEATURED_PRODUCT_IMAGES[id];
    const featuredMainImage = FEATURED_MAIN_IMAGE[id];
    return {
      id,
      slug: id,
      name,
      category,
      subcategorySlug: slugify(name),
      price: 55000 + Math.round(Math.random() * 150000),
      image: featuredMainImage ?? (featuredImages ? featuredImages[0] : PRODUCT_IMAGES[(i + (category === 'earrings' ? 8 : category === 'bracelets' ? 10 : 12)) % PRODUCT_IMAGES.length]),
      hoverImage: featuredImages ? featuredImages[1] : PRODUCT_IMAGES[(i + 1 + (category === 'earrings' ? 8 : category === 'bracelets' ? 10 : 12)) % PRODUCT_IMAGES.length],
      images: featuredImages,
      inStock: i % 2 === 0,
      metal: '24K Gold Vermeil',
      carat: (0.5 + i * 0.25).toFixed(2),
      description: `The ${name} is crafted for everyday luxury — a lab-grown diamond piece designed to be worn effortlessly, from morning meetings to evening celebrations.`
    };
  });
}

export const PRODUCTS = {
  earrings: genProducts('earrings', titles.earrings.length),
  bracelets: genProducts('bracelets', titles.bracelets.length),
  necklaces: genProducts('necklaces', titles.necklaces.length)
};

export const ALL_PRODUCTS = [
  ...PRODUCTS.earrings, ...PRODUCTS.bracelets, ...PRODUCTS.necklaces
];

export const TESTIMONIALS = [
  { name: 'Priya', location: 'London', quote: "I ordered from the UK and I honestly can't thank the HouseOfSeya team enough. From the very beginning, the whole experience felt personal and truly special.", img: 'https://images.unsplash.com/photo-1541679368093-5c967ac6de11?crop=entropy&cs=srgb&fm=jpg&w=800&q=85', rating: 5, product: 'Solitaire Studs', verified: true, date: '2026-06-14' },
  { name: 'Shivani & Jason', location: 'Mumbai', quote: 'Working with HouseOfSeya was seamless! Got my personalised piece done, and it came out beautiful. Thank you!', img: 'https://images.unsplash.com/photo-1540076156429-35ffe82b7870?crop=entropy&cs=srgb&fm=jpg&w=800&q=85', rating: 5, product: 'Custom Order', verified: true, date: '2026-05-02' },
  { name: 'Rashi', location: 'London', quote: 'Great experience! I bought a piece from HouseOfSeya, and it was perfect. I would 100% recommend if you are looking for diamond jewellery.', img: 'https://images.unsplash.com/photo-1631897817977-a1005c199b36?crop=entropy&cs=srgb&fm=jpg&w=800&q=85', rating: 5, product: 'Hoops & Huggies', verified: true, date: '2026-04-21' },
  { name: 'Divian', location: 'Delhi', quote: 'The experience with HouseOfSeya was simply amazing. The team was incredibly helpful, genuine and informative. It came out beautiful, exactly how I wanted it.', img: 'https://images.pexels.com/photos/30720972/pexels-photo-30720972.jpeg?auto=compress&cs=tinysrgb&w=800', rating: 5, product: 'Custom Order', verified: true, date: '2026-03-11' },
  { name: 'Ravi', location: 'USA', quote: 'They were able to beautifully turn a design into life making sure I was comfortable with every detail. 10/10 experience!', img: 'https://images.pexels.com/photos/10075092/pexels-photo-10075092.jpeg?auto=compress&cs=tinysrgb&w=800', rating: 5, product: 'Custom Order', verified: true, date: '2026-02-27' },
  { name: 'Meera', location: 'Bengaluru', quote: 'Stunning craftsmanship and the customer service was top notch. The studs are exactly what I wanted for everyday wear.', img: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?crop=entropy&cs=srgb&fm=jpg&w=800&q=85', rating: 4, product: 'Other Studs', verified: true, date: '2026-01-30' }
];

export const PROMISES = [
  'IGI Certified Diamonds', '24K Gold Vermeil', 'Secure Shipping',
  'Lifetime Buyback', '7-Day Easy Returns', 'BIS Hallmarked Jewellery'
];

export const STORES = [
  {
    city: 'Fort, Mumbai',
    image: 'https://images.unsplash.com/photo-1650389236412-e7413cbcf2fe?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    address: '1st Floor, 7 Kitab Mahal, 192 Dr D N Road, Fort, Mumbai 400001',
    hours: 'Mon–Sat, 10am–6:30pm',
    phone: '+91 8722447768'
  },
  {
    city: 'Defence Colony, Delhi',
    image: 'https://images.pexels.com/photos/28146843/pexels-photo-28146843.jpeg?auto=compress&cs=tinysrgb&w=1200',
    address: '2nd Floor, Building D19, Defence Colony, New Delhi 110024',
    hours: 'Mon–Sat, 10:30am–7pm',
    phone: '+91 8722447768'
  },
  {
    city: 'UB City, Bangalore',
    image: 'https://images.pexels.com/photos/279183/pexels-photo-279183.jpeg?auto=compress&cs=tinysrgb&w=1200',
    address: 'Level 1, UB City Mall, Vittal Mallya Road, Bengaluru 560001',
    hours: 'Mon–Sat, 10:30am–6:30pm',
    phone: '+91 8722447768'
  },
  {
    city: 'Jubilee Hills, Hyderabad',
    image: 'https://images.unsplash.com/photo-1624588057318-5f1b2eb81012?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    address: 'Road No. 36, Jubilee Hills, Hyderabad 500033',
    hours: 'Mon–Sat, 10:30am–6:30pm',
    phone: '+91 8722447768'
  }
];

export const PRESS = ['Vogue','ELLE','Grazia','Femina','Financial Express','The Hindu','News18','Republic','Mid-day','The Style List','Wedding Vows','Khush'];

export const FAQS = [
  { group: 'The Diamond, First', q: 'What are lab-grown diamonds?', a: 'Lab-grown diamonds are real diamonds, created using the same carbon-crystallization process that forms diamonds underground, replicated in a controlled lab environment instead of over billions of years. They are chemically, physically, and optically identical to mined diamonds — same hardness, same brilliance, same sparkle. Every House of Seya diamond comes with IGI certification.' },
  { group: 'The Diamond, First', q: 'Are lab-grown diamonds real diamonds?', a: "Yes. A lab-grown diamond is exactly like a natural diamond in every way that matters, except instead of being mined from the earth, it's grown in a lab. It sparkles the same, comes in the same colors and clarities, and offers the same permanence — at a fraction of the price of an equivalent mined stone." },
  { group: 'The Diamond, First', q: 'Can anyone tell the difference between a lab-grown and a mined diamond?', a: 'No. Lab-grown diamonds share the same physical, chemical, and optical properties as natural diamonds. Even trained jewelers cannot tell them apart without specialized gemological equipment.' },
  { group: 'The Diamond, First', q: "Are House of Seya's diamonds IGI certified?", a: 'Yes. Every diamond we set is IGI (International Gemological Institute) certified, guaranteeing cut, color, clarity, and carat weight to a globally recognized standard.' },
  { group: 'The Diamond, First', q: 'Do lab-grown diamonds lose their shine over time?', a: "No. With a hardness of 10 on the Mohs scale, our diamonds retain their brilliance and clarity permanently, making them ideal for daily wear as well as pieces you'll treasure for years." },
  { group: 'The Diamond, First', q: 'Why choose lab-grown diamonds over mined diamonds?', a: 'Three reasons our customers choose lab-grown: a clean, conflict-free, traceable origin; the exact same brilliance, hardness, and durability as mined diamonds; and meaningfully better value, letting you invest in a larger stone or a more intricate design without compromising your budget.' },

  { group: 'The Setting: 24K Gold Vermeil', q: 'What is gold vermeil, and how is it different from gold plating?', a: 'Gold vermeil is a real, regulated jewelry standard — a rich layer of genuine gold bonded over a sterling silver base, at least 2.5 microns thick. Ordinary "gold plated" jewelry has no such minimum and is often closer to 0.5 microns, which fades within weeks. Vermeil, done properly, is built to hold its richness and durability for years.' },
  { group: 'The Setting: 24K Gold Vermeil', q: "How thick is House of Seya's gold vermeil, and why does that matter?", a: 'Our diamonds are set in 24K gold vermeil, plated at 2.5 microns — the legal international minimum for a piece to genuinely be called vermeil at all. A lot of jewelry marketed as vermeil is actually plated well below this, often around 0.5 microns, which legally only qualifies as gold plating. This means the setting around your diamond is held to a real, defensible standard, built for daily life, not just special occasions.' },
  { group: 'The Setting: 24K Gold Vermeil', q: 'Can I wear House of Seya jewelry in the shower or every day?', a: 'Yes. Our 2.5-micron gold vermeil is built to handle daily wear and water exposure, so your diamonds can go wherever you go, shower included.' },
  { group: 'The Setting: 24K Gold Vermeil', q: 'Why is gold vermeil more affordable than a solid gold diamond setting?', a: 'Because vermeil uses a metal base beneath the gold layer rather than gold throughout, it lets us put more of your budget toward the diamond itself — a genuine, certified stone — rather than the setting material.' },

  { group: 'Buying With Confidence', q: 'What is your return, exchange, and buyback policy?', a: 'We offer 7-day returns and exchanges, along with a Lifetime Buyback Program on eligible pieces, so you can shop with confidence today and know your jewelry continues to hold value well beyond your purchase.' },
  { group: 'Buying With Confidence', q: 'Is shipping secure?', a: 'Yes, every order is securely packaged and shipped with tracking, so you always know where your piece is on its way to you.' },
  { group: 'Buying With Confidence', q: 'How do I care for my House of Seya jewelry?', a: 'Store pieces in a dry, airtight pouch away from direct sunlight. Apply makeup, perfume, and hairspray before putting your jewelry on, not after. Wipe gently with a soft cloth after each wear to keep your diamond and its setting looking their brilliant best.' },
  { group: 'Buying With Confidence', q: 'Is House of Seya jewelry a good gifting option?', a: "Yes — you're gifting an IGI-certified diamond in a richly plated 24K gold vermeil setting, backed by our buyback and returns policies, at a price point that makes fine diamond jewelry gifting more accessible without feeling any less special." },
  { group: 'Buying With Confidence', q: 'What is the base metal beneath the gold vermeil?', a: "Our gold vermeil is set over a BIS hallmarked sterling silver base, certified to the purity standard set by India's Bureau of Indian Standards — giving every piece a solid, certified foundation beneath its 24K gold finish." },
  { group: 'Buying With Confidence', q: "How do I know I'm buying a genuine, certified diamond?", a: "Every diamond ships with its own IGI certificate, independently verifying its cut, color, clarity, and carat weight. You're not just taking our word for it — you have the documentation to prove exactly what you own." }
];

export const HERO_TILES = [
  {
    title: 'Crafted by us,\nDesigned by you',
    cta: 'Customise',
    image: 'https://images.unsplash.com/photo-1633934542430-0905ccb5f050?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85',
    href: '/services/customise#build-your-custom-piece'
  },
  {
    title: 'Follow The Feeling',
    cta: 'About us',
    image: 'https://images.pexels.com/photos/10976654/pexels-photo-10976654.jpeg?auto=compress&cs=tinysrgb&w=1400',
    href: '/about'
  }
];



// Each top-level category's `sub` list puts the specific subcategories first
// and the "All X" catch-all entry last, so it sits at the bottom of the dropdown.
const subLinks = (category, label) => [
  ...titles[category].map((name) => ({ label: name, href: `/collections/${category}/${slugify(name)}` })),
  { label: `All ${label}`, href: `/collections/${category}` },
];

export const NAV_LINKS = [
  { label: 'Earrings', href: '/collections/earrings', sub: subLinks('earrings', 'Earrings') },
  { label: 'Necklaces', href: '/collections/necklaces', sub: subLinks('necklaces', 'Necklaces') },
  { label: 'Bracelets', href: '/collections/bracelets', sub: subLinks('bracelets', 'Bracelets') },
  { label: 'Services', href: '/services/gifting', sub: [
    { label: 'Gifting', href: '/services/gifting' },
    { label: 'Customise', href: '/services/customise' }
  ] },
  { label: 'Jewellery Guide', href: '/pages/diamond-education', sub: [
    { label: 'Diamond Education', href: '/pages/diamond-education' },
    { label: 'Gold Vermeil', href: '/pages/gold-vermeil' },
    { label: "FAQ's", href: '/faqs' },
    { label: 'Blogs', href: '/blogs' }
  ] }
];

// Placeholder blog posts, one or more per category/subcategory — swap
// `body` for the client's real copy per post when supplied. `category`
// matches PRODUCTS keys ('earrings'/'necklaces'/'bracelets') so posts can be
// surfaced on the matching Collection page; `href` is the post's slug.
export const BLOGS = [
  {
    slug: 'solitaire-studs-everyday-guide',
    category: 'earrings',
    title: 'The Solitaire Stud: A Guide to Everyday Sparkle',
    excerpt: 'Why a single, brilliant diamond is the most versatile piece in your jewellery box.',
    image: 'https://images.unsplash.com/photo-1693212793204-bcea856c75fe?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
    body: 'A solitaire stud features a single, brilliant lab-grown diamond as the centerpiece — clean, timeless, and endlessly wearable. Every House of Seya solitaire diamond is IGI certified, so the brilliance you see is backed by independent, verifiable documentation.'
  },
  {
    slug: 'hoops-huggies-styling',
    category: 'earrings',
    title: 'Hoops vs. Huggies: Which Earring Style Fits Your Day?',
    excerpt: 'From close-to-the-lobe huggies to statement hoops — how to pick your everyday go-to.',
    image: 'https://images.pexels.com/photos/5370644/pexels-photo-5370644.jpeg?auto=compress&cs=tinysrgb&w=900',
    body: 'Huggies sit close to the earlobe, ideal for all-day, low-profile wear. Larger hoops make more of a statement and are great for adding instant polish to a simple outfit. Both are finished in 24K gold vermeil, built for daily wear.'
  },
  {
    slug: 'pendant-layering-guide',
    category: 'necklaces',
    title: 'The Art of Layering: Pendants & Trinket Necklaces',
    excerpt: 'How to stack a diamond pendant with trinket necklaces for a considered, collected look.',
    image: 'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
    body: 'A pendant is often the one piece of jewellery someone wears every single day. Pair a shorter trinket chain with a longer pendant necklace for dimension, or wear two or three together at different lengths for a personalized look.'
  },
  {
    slug: 'mangalsutra-modern-tradition',
    category: 'necklaces',
    title: 'Mangalsutra, Made Modern',
    excerpt: 'Honouring tradition with a certified lab-grown diamond, in a design built for daily life.',
    image: 'https://images.pexels.com/photos/20838859/pexels-photo-20838859.jpeg?auto=compress&cs=tinysrgb&w=900',
    body: 'A modern mangalsutra deserves modern standards — a certified, ethically sourced diamond, fully documented, worn daily as a symbol that deserves nothing less than complete transparency about what it is made of.'
  },
  {
    slug: 'tennis-bracelet-guide',
    category: 'bracelets',
    title: 'The Tennis Bracelet: A House of Seya Staple',
    excerpt: 'A line of brilliant lab-grown diamonds, built to be worn every single day.',
    image: 'https://images.pexels.com/photos/10976654/pexels-photo-10976654.jpeg?auto=compress&cs=tinysrgb&w=900',
    body: 'The tennis bracelet is one of the most enduring silhouettes in fine jewellery — a continuous line of diamonds set in 24K gold vermeil over a BIS hallmarked sterling silver base, built for daily wear.'
  },
  {
    slug: 'gold-vermeil-vs-plated',
    category: null,
    title: 'Gold Vermeil vs. Gold Plated: What the Label Actually Means',
    excerpt: 'The 2.5-micron standard that separates real vermeil from ordinary gold plating.',
    image: 'https://images.unsplash.com/photo-1633934542430-0905ccb5f050?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
    body: 'Gold vermeil is a real, regulated jewelry standard — a rich layer of genuine gold bonded over a sterling silver base, at least 2.5 microns thick. Ordinary "gold plated" jewelry has no such minimum and is often closer to 0.5 microns, which fades within weeks.'
  },
  {
    slug: 'jewelry-not-an-investment',
    category: 'Jewelry Guide',
    title: "Stop Treating Your Jewelry Like an Investment — Here's What to Do Instead",
    excerpt: "For generations, Indian buyers have been taught to treat jewelry as an investment. Here's why that idea deserves a rethink — and how to actually protect your money while still wearing what you love.",
    image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?crop=entropy&cs=srgb&fm=jpg&w=900&q=85',
    body: "For as long as most of us can remember, jewelry in India has carried a second job. It isn't just something you wear — it's something you're supposed to hold onto, protect, and eventually, if the story goes as planned, sell back for a profit.",
    sections: [
      {
        type: 'paragraph',
        text: "For as long as most of us can remember, jewelry in India has carried a second job. It isn't just something you wear — it's something you're supposed to hold onto, protect, and eventually, if the story goes as planned, sell back for a profit. Ask most Indian households why they bought a particular gold or diamond piece, and somewhere in the answer you'll hear the word “investment.”"
      },
      {
        type: 'paragraph',
        text: "It's such a familiar idea that we rarely stop to question it. But it's worth asking: is jewelry actually a good investment? And more importantly — is treating it like one costing you the thing jewelry was supposed to give you in the first place?"
      },
      {
        type: 'heading',
        text: "Where the “Investment” Idea Comes From"
      },
      {
        type: 'paragraph',
        text: "The instinct isn't irrational. For generations, gold was one of the few assets Indian households could reliably access, understand, and trust — especially at a time when formal investment options were limited, and gold jewelry doubled as both adornment and a store of value passed down through families. Buying jewelry wasn't just a purchase; it was financial planning, wrapped in something beautiful enough to wear to a wedding."
      },
      {
        type: 'paragraph',
        text: "That instinct made sense in a different economic era. But holding onto it today, largely unquestioned, means a lot of jewelry — including pieces people genuinely love — ends up spending most of its life in a locker instead of on the person it was bought for."
      },
      {
        type: 'heading',
        text: "The Real Cost of Treating Jewelry as an Investment"
      },
      {
        type: 'paragraph',
        text: "Here's what rarely gets talked about: jewelry is actually a poor investment vehicle, once you account for the full picture."
      },
      {
        type: 'paragraph',
        boldText: "Making charges and margins rarely come back to you.",
        text: " When you buy a piece, you're paying for the metal, the diamond or stone, and the craftsmanship that shaped it. When you sell it back, most buyers only offer you the raw material value — the gold weight, or a fraction of the diamond's worth — not what you actually paid. That gap is money that simply disappears."
      },
      {
        type: 'paragraph',
        boldText: "It sits idle, which is the opposite of what an investment should do.",
        text: " A stock, a bond, a gold ETF — these are built to be held precisely so they can grow quietly in the background while you go about your life. Jewelry can't do that. A piece sitting in a locker isn't earning anything; it's just sitting there, often insured, sometimes forgotten, doing nothing for you financially or otherwise."
      },
      {
        type: 'paragraph',
        boldText: "And the emotional cost is real too.",
        text: " Jewelry chosen for how it makes you feel — a gift, a milestone piece, something you saved up for — deserves to be worn, not treated like a financial instrument you're afraid to touch. Ask anyone who's kept a beloved piece locked away “for its value” how often they actually got to enjoy it. Usually, the honest answer is: barely at all."
      },
      {
        type: 'heading',
        text: "Separate the Investment From the Jewelry"
      },
      {
        type: 'paragraph',
        text: "Here's the shift worth making: stop asking your jewelry to be your investment plan, and let it just be jewelry."
      },
      {
        type: 'paragraph',
        text: "If building financial security through gold matters to you — and it's a completely reasonable goal — there are instruments built specifically for that purpose: Sovereign Gold Bonds, gold ETFs, or digital gold, all of which track gold's value transparently, without the markup of craftsmanship or the illiquidity of a physical piece. These are designed to be sold, tracked, and grown as actual financial assets."
      },
      {
        type: 'paragraph',
        text: "Once your investment goals are handled separately, something freeing happens: your jewelry no longer has to justify its existence financially. You're free to choose pieces because you genuinely love them, wear them because they make you feel like yourself, and never have to weigh “how much is this worth if I need to sell it” against “how much do I love wearing this.”"
      },
      {
        type: 'paragraph',
        text: "That's precisely the gap House of Seya was built to sit in. When a diamond doesn't carry the enormous premium of a mined stone, and gold vermeil delivers real richness without the price of solid gold throughout, jewelry stops needing to double as a safety net. It can just be what it was always meant to be — something you choose because it's beautiful, and wear because you love it, not because you're protecting a future resale value."
      },
      {
        type: 'heading',
        text: "You Shouldn't Have to Give Up a Piece to Get Its Value"
      },
      {
        type: 'paragraph',
        text: "The other part of the old model that deserves rethinking: the idea that the only way to ever “realize” value from a piece is to give it up entirely — melt it down, sell it back for a fraction of what you paid, and lose it forever."
      },
      {
        type: 'paragraph',
        text: "That's part of why we built our Lifetime Buyback Program the way we did. It exists as a safety net for the pieces you no longer wear, not as the reason you bought them in the first place. Your jewelry doesn't have to earn its keep by sitting untouched — you can wear it constantly, love it fully, and know that if your taste changes down the line, there's still a path to real value without having started from a place of financial anxiety about a piece you were supposed to be enjoying."
      },
      {
        type: 'heading',
        text: "Wear It. That Was the Whole Point."
      },
      {
        type: 'paragraph',
        text: "Jewelry was never meant to be a locker's most frequent visitor. It was meant to catch the light at dinner, sit at your collarbone on an ordinary Tuesday, and make you feel a little more like yourself every time you put it on."
      },
      {
        type: 'paragraph',
        text: "Put your investment goals where they belong — in instruments built for growth. And put your jewelry where it belongs too: on you."
      }
    ]
  }
];

export const formatPrice = (n) => {
  if (n === null || n === undefined || n === '') return '';
  const num = typeof n === 'number' ? n : Number(n);
  if (isNaN(num)) return '';
  return '₹' + Math.round(num).toLocaleString('en-IN');
};

// TODO: replace with the real House of Seya business WhatsApp number,
// in international format with no "+" or spaces (e.g. "919876543210").
export const WHATSAPP_NUMBER = '918722447768';

export const buildWhatsAppOrderMessage = (items) => {
  const lines = [
    'Hi House of Seya! I would like to place an order:',
    '',
    ...items.map((item) => `• ${item.name}${item.variantName ? ` (${item.variantName})` : ''} x${item.qty}`),
  ];
  return lines.join('\n');
};

export const buildWhatsAppOrderUrl = (items) => {
  const message = buildWhatsAppOrderMessage(items);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const buildProductWhatsAppUrl = (product) => {
  const message = `Hi House of Seya! I'd like to buy the ${product.name} (${formatPrice(product.price)}). Is it available?`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

// Dummy content for the About page, styled after houseofquadri.com/pages/about-us
export const ABOUT_CONTENT = {
  hero: {
    image: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85',
    tagline: 'Our Story',
    title: 'Follow the Feeling'
  },
  intro: {
    title: 'Follow the Feeling',
    body: "House of Seya was built on a simple instinct: jewellery should feel like an extension of you, not an occasion you wait for. We design pieces for the everyday — the ones you reach for without thinking twice, and the ones that quietly mark the moments that matter."
  },
  philosophy: {
    tagline: 'Because it Feels Right',
    title: 'Diamonds that don’t cost the Earth',
    body: 'Every House of Seya diamond is lab-grown — chemically, physically, and optically identical to a mined diamond, IGI certified, and priced with a lot more sense. Kinder to the planet, and kinder to you.',
    image: 'https://images.unsplash.com/photo-1543294001-f7cd5d7fb516?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85'
  },
  everyday: {
    tagline: 'Today > Someday',
    title: 'Jewellery for now, not just for someday',
    body: "We don't believe fine jewellery should sit in a box waiting for a special occasion. Our pieces are made to be worn daily — layered, stacked, and lived in — so the moments that matter are the ones you're already having.",
    image: 'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85'
  },
  founder: {
    tagline: 'Homegrown in India',
    name: 'Seya Kapoor',
    title: 'Founder, House of Seya',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&w=800&q=85',
    body: "House of Seya began in 2021 out of a frustration with an industry that made fine jewellery feel distant and transactional. Starting with a single collection of lab-grown diamond studs, the brand has grown into a full house of everyday and celebration pieces — still designed, sourced, and shipped from India, with the same intention it started with."
  },
  experience: {
    tagline: 'The House of Seya Experience',
    title: 'Jewellery shopping, made personal',
    body: 'From your first message to us to the moment your piece arrives, every House of Seya order is looked after by a real person — not a queue. Need help choosing a gift, customising a piece, or sizing a ring? We’re a message away.',
    image: 'https://images.pexels.com/photos/10976654/pexels-photo-10976654.jpeg?auto=compress&cs=tinysrgb&w=1200'
  }
};

// Content for the Diamond Education page, structured verbatim from Diamond Guide.docx
export const DIAMOND_EDUCATION_CONTENT = {
  hero: {
    title: 'The Complete Diamond Guide',
    image: 'https://images.unsplash.com/photo-1543294001-f7cd5d7fb516?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85'
  },
  whatAreLabGrown: {
    title: 'What Are Lab-Grown Diamonds?',
    p1: "Lab-grown diamonds are real diamonds — not imitations, and not a separate category of gemstone. They're created using one of two established methods, CVD (Chemical Vapour Deposition — A standard at HOS) or HPHT (High Pressure High Temperature), which replicate the exact natural process that forms diamonds underground, just inside a controlled lab environment instead of the earth's crust over billions of years.",
    p2: "The result is a stone that is chemically, physically, and optically identical to a mined diamond: the same carbon crystal structure, the same hardness, the same brilliance and fire. Every House of Seya diamond is IGI certified, so that identity is independently documented, not just claimed.",
    image: 'https://images.unsplash.com/photo-1624588057318-5f1b2eb81012?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85'
  },
  fourCs: {
    title: "THE 4C'S OF DIAMONDS",
    intro: 'Every diamond, lab-grown or mined, is evaluated on the same four characteristics. Understanding them is the single most useful thing you can do before buying.',
    items: [
      {
        title: 'Cut',
        body: "Cut is the most important of the 4Cs, and the one most buyers underweight. It refers to how well a diamond's facets interact with light — a well-cut diamond reflects light back through the top of the stone, creating the brilliance and sparkle diamonds are prized for. A poorly cut diamond can look dull even with excellent color and clarity. For the best balance of beauty and value, look for an Excellent or Very Good cut grade."
      },
      {
        title: 'Colour',
        body: "Colour measures how close to colourless a white diamond is, graded on a scale from D (completely colourless) to Z (noticeably tinted). The closer to D, the rarer and more valuable the stone. Most buyers find the best value in the G–H range, where any warmth is essentially invisible to the naked eye but the price is meaningfully lower than a D-E-F stone."
      },
      {
        title: 'Clarity',
        body: "Clarity measures internal inclusions and external blemishes — natural characteristics formed during the diamond's growth. Grades range from Flawless (extremely rare) down to Included (visible inclusions to the naked eye). VS1–VS2 and SI1 grades typically offer inclusions invisible without magnification, making them the sweet spot for value-conscious buyers."
      },
      {
        title: 'Carat',
        body: "Carat measures a diamond's weight, not its size directly — though the two are closely related. One carat equals 200 milligrams. Because larger diamonds are rarer, price increases disproportionately as carat weight goes up. A well-cut diamond can also appear larger than its carat weight suggests, which is part of why cut quality matters more than raw size."
      }
    ]
  },
  comparison: {
    title: 'Lab-Grown vs. Natural Diamond: A Clear Comparison',
    headers: ['Factor', 'Lab-Grown Diamond', 'Natural Mined Diamond'],
    rows: [
      { factor: 'Chemical Composition', labGrown: '100% pure carbon', natural: '100% pure carbon' },
      { factor: 'Hardness (Mohs Scale)', labGrown: '10', natural: '10' },
      { factor: 'Optical Properties', labGrown: 'Identical brilliance and fire', natural: 'Identical brilliance and fire' },
      { factor: 'Formation Time', labGrown: 'Weeks, in a controlled lab', natural: 'Billions of years, underground' },
      { factor: 'Visible to the Naked Eye', labGrown: 'Indistinguishable without specialized equipment', natural: 'Indistinguishable without specialized equipment' },
      { factor: 'Origin Traceability', labGrown: 'Fully traceable, conflict-free by nature', natural: 'Traceable only where supply chain is certified' },
      { factor: 'Price for Equal Quality', labGrown: 'Significantly lower', natural: 'Higher, due to mining and distribution costs' }
    ],
    concluding: 'The two are graded on the exact same 4Cs scale, by the same gemological institutes. The only meaningful difference is origin — and that difference is precisely what makes lab-grown diamonds more accessible without compromising on what a diamond actually is.'
  },
  certification: {
    title: 'Understanding IGI Certification',
    p1: "A diamond certificate is effectively an identity document for your stone. It's issued by an independent gemological laboratory — not the jeweler selling the diamond — after the stone has been examined and graded under controlled conditions. This independence is what makes a certificate meaningful: it's a second, unbiased opinion on exactly what you're buying.",
    p2: "House of Seya diamonds are certified by IGI (International Gemological Institute), one of the world's most widely recognized and trusted grading authorities.",
    image: 'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85',
    headers: ['What IGI Certifies', 'Why It Matters to You'],
    rows: [
      { certifies: 'Cut grade', matters: 'Confirms the diamond is shaped for maximum light return' },
      { certifies: 'Colour grade', matters: 'Verifies the exact colour on the recognized grading scale' },
      { certifies: 'Clarity grade', matters: 'Documents all internal and external characteristics' },
      { certifies: 'Carat weight', matters: 'Confirms the precise weight of the stone' },
      { certifies: 'Diamond origin', matters: 'Identifies the stone as laboratory-grown' },
      { certifies: 'Measurements & proportions', matters: 'Confirms the stone matches its stated cut and dimensions' }
    ],
    concluding: "Every House of Seya diamond ships with its IGI certificate. It's not an optional upgrade — it's how we make sure you never have to simply take our word for what you're buying."
  },
  buyingMistakes: {
    title: 'Common Diamond Buying Mistakes',
    items: [
      { num: '01', text: 'Prioritising carat size over cut quality — a smaller, well-cut diamond will often out-sparkle a larger, poorly cut one.' },
      { num: '02', text: 'Buying without a certificate, or accepting a certificate from an unfamiliar, non-independent lab.' },
      { num: '03', text: 'Assuming all diamonds within a grade look identical — cut quality and fluorescence can meaningfully affect appearance even within the same clarity or colour grade.' },
      { num: '04', text: 'Not asking whether the stone is lab-grown or mined — reputable sellers should always disclose this clearly, not leave it ambiguous.' }
    ]
  },
  myths: {
    title: 'Common Myths About Lab-Grown Diamonds',
    items: [
      {
        myth: 'Lab-grown diamonds are fake diamonds.',
        reality: 'A lab-grown diamond is exactly as real as a mined one — same carbon structure, same hardness, same optical properties. The only difference is where it was created.'
      },
      {
        myth: 'You can tell a lab-grown diamond apart with the naked eye.',
        reality: "You cannot. Even trained gemologists need specialized equipment, like spectroscopy, to distinguish origin — visual inspection alone isn't enough."
      },
      {
        myth: "Lab-grown diamonds won't hold up over time.",
        reality: 'With a hardness of 10 on the Mohs scale — the same as natural diamonds — lab-grown diamonds are exceptionally durable and are not more prone to damage or dulling with age.'
      },
      {
        myth: "Certification doesn't matter for lab-grown diamonds.",
        reality: "If anything, certification matters just as much. It's the only independent confirmation of the exact cut, colour, clarity, and carat weight you're paying for, regardless of origin."
      }
    ]
  },
  faqs: [
    {
      q: 'Are lab-grown diamonds graded on the same scale as natural diamonds?',
      a: 'Yes. Lab-grown diamonds are graded using the same 4Cs — cut, colour, clarity, and carat weight — as natural diamonds. At House of Seya, every diamond comes with full IGI grading documentation for complete transparency.'
    },
    {
      q: 'Do lab-grown diamonds lose their shine over time?',
      a: 'No. Lab-grown diamonds retain their brilliance and clarity permanently. With a hardness of 10 on the Mohs scale, they\'re extremely durable and suitable for daily wear as well as pieces meant to last a lifetime.'
    },
    {
      q: 'How much more affordable are lab-grown diamonds than mined diamonds?',
      a: 'Generally, lab-grown diamonds offer meaningfully better value for the same size and quality, since the supply chain avoids the costs associated with mining, exploration, and distribution of natural stones.'
    },
    {
      q: 'What\'s the difference between CVD and HPHT lab-grown diamonds?',
      a: 'Both are legitimate methods of growing diamonds in a lab. CVD (Chemical Vapour Deposition) grows a diamond layer by layer from a carbon-rich gas. HPHT (High Pressure High Temperature) replicates the natural underground conditions using extreme pressure and heat. Both produce chemically identical, real diamonds.'
    },
    {
      q: 'Why does IGI certification matter if I trust the brand I\'m buying from?',
      a: 'Because a certificate is independent of the seller. It\'s issued by a third-party gemological lab with no stake in the sale, so it protects you even if your assessment of the brand later changes. It\'s documentation you keep, not just a claim you were told.'
    }
  ]
};

// Content for the Customise page, structured from Customise Page.docx
export const CUSTOMISE_CONTENT = {
  hero: {
    image: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85',
    headline: 'Your Diamond,\nYour Design',
    subhead: 'At House of Seya, our customisation service lets you build a piece around the diamond you choose — guided every step of the way, so what you end up with is genuinely, personally yours.',
    cta: 'Start Customising'
  },
  intro: {
    body: 'At House of Seya, our customisation service lets you build a piece around the diamond you choose — guided every step of the way, so what you end up with is genuinely, personally yours.'
  },
  step1: {
    title: 'Step 1: Choose Your Piece',
    body: "This is where your design begins. Select the foundation for your custom piece — ring, earrings, necklace, or bracelet — and we'll guide you through the rest from there.",
    options: ['Rings', 'Earrings', 'Necklace', 'Bracelet']
  },
  step2: {
    title: 'Step 2: Choose Your Diamond',
    body1: 'Every House of Seya piece starts with the diamond, not the setting. Choose from a range of diamond shapes, each with its own character — round for maximum brilliance, oval for an elongating effect, emerald for quiet, architectural elegance, and more.',
    body2: "We'll guide you through the essentials of the 4Cs — cut, colour, clarity, and carat — so you can make an informed choice, not a guess. Every diamond you select is IGI certified, with full documentation of exactly what you're choosing.",
    microCallout: "Why cut matters most: A diamond's cut determines how well it reflects light — it's the single biggest factor in how much a diamond actually sparkles, more than size or clarity. We'll help you prioritise it.",
    shapes: ['Round', 'Oval', 'Emerald', 'Cushion', 'Pear', 'Marquise', 'Princess']
  },
  step3: {
    title: 'Step 3: Choose Your Setting',
    body1: 'From Pavé to Halo to Bezel, every setting holds a different presence. A halo makes your diamond look larger and catches more light. A bezel setting wraps the diamond in metal for a modern, protective look, ideal for daily wear. Pavé adds a continuous line of brilliance around the band.',
    body2: "We'll help you choose what complements your diamond and fits your lifestyle — whether that's a setting built to withstand daily wear or one designed to make a bigger statement.",
    settings: ['Solitaire', 'Halo', 'Pavé', 'Bezel', 'Cluster']
  },
  step4: {
    title: 'Step 4: Personalise It',
    body: 'This is where it becomes truly yours. Think a hidden halo beneath the main stone, a personal engraving on the inside of a band or the back of a pendant, or a whisper of hidden diamonds that catch light distinctively when you move. Small touches that make a piece deeply personal.',
    options: [
      'Hidden diamond accents',
      'Engraving (initials, dates, or a short message)',
      'Birthstone or coloured stone accents'
    ]
  },
  step5: {
    title: 'Step 5: Choose Your Finish',
    body: 'We craft every custom piece in 24K gold vermeil — a rich, 2.5-micron layer of pure gold set over BIS hallmarked sterling silver. That thickness is the genuine international minimum for the vermeil label, well above the roughly 0.5 microns typical of ordinary gold plating, giving you real richness and everyday durability without the price of solid gold.',
    finishes: ['Yellow Gold', 'Rose Gold', 'White Gold']
  },
  process: {
    title: 'From Your Vision to Your Doorstep',
    body: "Once you've built your design, a House of Seya advisor will reach out to walk through your selections, confirm your diamond's certification details, and share a rendering of your piece before it's made — so there are no surprises between your vision and the final piece.",
    editorialNote: '[Suggested process copy — confirm actual turnaround time, deposit/payment structure, and delivery timeline with your operations team before publishing, since these numbers will be customer-facing commitments.]',
    steps: [
      { title: 'Share Your Vision', body: 'Send us your idea — a sketch, a reference photo, or just a description of what you\'re picturing.' },
      { title: 'We Design It', body: 'Our team conceptualises the piece and shares a rendering for your review before anything is made.' },
      { title: 'It Comes to Life', body: 'Once you approve the design, your piece is handcrafted and shipped straight to you.' }
    ]
  },
  faqs: [
    {
      q: 'Can I really design my own piece from scratch, or am I choosing from templates?',
      a: 'Both — you can build a fully custom design around your chosen diamond, or start from one of our existing settings and personalise it with engraving, accents, or a different finish. Either way, the piece is built around your certified diamond, not a generic template.'
    },
    {
      q: 'Will my custom diamond still be IGI certified?',
      a: 'Yes. Every diamond available through our customisation service is IGI certified, regardless of the shape, setting, or personalisation you choose.'
    },
    {
      q: 'How long does a custom piece take to make?',
      a: 'A custom piece generally takes about 4-5 weeks time depending on intricacy. Best things are never rushed.'
    },
    {
      q: 'Is the gold vermeil finish the same quality across custom and ready-made pieces?',
      a: 'Yes. Every custom piece is finished in the same 2.5-micron 24K gold vermeil over BIS hallmarked sterling silver used across our entire collection — customisation changes the design, never the material standard.'
    },
    {
      q: 'What if I\'m not sure exactly what I want?',
      a: 'That\'s exactly what the guided steps are for. Start with the diamond shape or piece type you\'re drawn to, and our advisors will help narrow down the rest based on your style and how you plan to wear the piece.'
    }
  ],
  possibilities: [
    { title: 'Start with an Idea', body: 'A photo, a sketch, or even a piece you already own — we can work from almost anything.', image: 'https://images.unsplash.com/photo-1633934542430-0905ccb5f050?crop=entropy&cs=srgb&fm=jpg&w=900&q=85' },
    { title: 'Choose Your Diamond', body: 'Pick a shape and carat that feels like you — every stone is IGI certified.', image: 'https://images.unsplash.com/photo-1543294001-f7cd5d7fb516?crop=entropy&cs=srgb&fm=jpg&w=900&q=85' },
    { title: 'Define Your Setting', body: 'Solitaire, halo, vintage-inspired — we\'ll help you land on a setting that suits the stone and the story.', image: 'https://images.unsplash.com/photo-1650389236412-e7413cbcf2fe?crop=entropy&cs=srgb&fm=jpg&w=900&q=85' },
    { title: 'Add a Personal Touch', body: 'Engravings, birthstones, a hidden detail only you know about — the finishing touches are yours to choose.', image: 'https://images.pexels.com/photos/279183/pexels-photo-279183.jpeg?auto=compress&cs=tinysrgb&w=900' }
  ],
  considerations: [
    { title: 'Metals', body: 'We work in 24K gold vermeil over a BIS hallmarked sterling silver base, available in yellow, white, and rose gold.' },
    { title: 'Diamond Shapes', body: 'Round, oval, princess, emerald, radiant, pear, heart, cushion, marquise, or asscher — your call.' },
    { title: 'Timeline', body: 'Custom pieces typically take 3–4 weeks depending on complexity. The best things are worth the wait.' }
  ]
};

// Dummy content for the Gifting page, structured after
// houseofquadri.com/pages/gifting (layout only — copy is House of Seya's own).
export const GIFTING_CONTENT = {
  hero: {
    image: 'https://images.pexels.com/photos/28146843/pexels-photo-28146843.jpeg?auto=compress&cs=tinysrgb&w=2000',
    tagline: 'The Art of Gifting',
    title: 'A Gift They\'ll Actually Wear'
  },
  categories: [
    { title: 'For Her', body: 'Birthdays, anniversaries, or just because — a piece that says more than the card ever could.', image: 'https://images.unsplash.com/photo-1624588057318-5f1b2eb81012?crop=entropy&cs=srgb&fm=jpg&w=900&q=85', href: '/collections/new-collection' },
    { title: 'Celebrating Her', body: 'For the mothers, sisters, and daughters who\'ve earned something as considered as they are.', image: 'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?crop=entropy&cs=srgb&fm=jpg&w=900&q=85', href: '/collections/new-collection' },
    { title: 'Ensemble Gifting', body: 'Bridesmaid keepsakes, corporate gifting, or a curated set — talk to a consultant about gifting at scale.', image: 'https://images.pexels.com/photos/20838859/pexels-photo-20838859.jpeg?auto=compress&cs=tinysrgb&w=900', href: null }
  ],
  readyToShip: {
    title: 'Ready to Ship',
    body: 'Running short on time? Our in-stock pieces ship within 2–3 days, so the gift still arrives right on time.'
  },
  supporting: [
    { title: 'Planned to Perfection', body: 'Not sure what to pick? Message us and we\'ll help you land on something they\'ll genuinely love.', image: 'https://images.unsplash.com/photo-1650389236412-e7413cbcf2fe?crop=entropy&cs=srgb&fm=jpg&w=900&q=85' },
    { title: 'Gift Packaging', body: 'Every order arrives beautifully packaged, ready to hand over exactly as it is — no extra wrapping needed.', image: 'https://images.pexels.com/photos/279183/pexels-photo-279183.jpeg?auto=compress&cs=tinysrgb&w=900' }
  ],
  faqs: [
    { q: 'Can I exchange it if they don\'t like it?', a: 'Yes. In-stock pieces can be returned unused within 7 days for a full exchange or store credit.' },
    { q: 'How fast can it ship?', a: 'In-stock pieces typically ship within 2–3 days. Message us if you need it sooner and we\'ll do what we can.' },
    { q: 'How is it packaged?', a: 'Every piece arrives in House of Seya\'s signature packaging, ready to gift as-is.' }
  ]
};

export const buildAppointmentMessage = ({ name, phone, store, date, notes }) => {
  const lines = [
    'Hi House of Seya! I would like to book an appointment:',
    '',
    `Name: ${name}`,
    `Phone: ${phone}`,
    `Store: ${store}`,
    `Preferred date: ${date}`,
    ...(notes ? ['', `Notes: ${notes}`] : []),
  ];
  return lines.join('\n');
};

export const buildAppointmentUrl = (details) => {
  const message = buildAppointmentMessage(details);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};
